import React from "react";
import { shallowEqual } from "react-redux";
import { useUscLabel } from "../../../../../utils/labels";
import { useUscSelector } from "../../../../../redux/store";
import UscCashPrice from "../../price/UscCashPrice";
import { getSimplifiedTotalPriceSelector, getTotalPriceSelector } from "../../../../../utils/priceUtils";
import Text from "../../../../../../shared-components/toyota/styles/atoms/Text";
import * as Styles from "./UscBasketDetailsTotalPrice.styles";
import UscInlinePrices from "../../price/UscInlinePrices";
import InlineDisclaimer from "../../InlineDisclaimer";
import { UscDisclaimerType } from "../../../../../../shared-logic/types/UscCommonTypes";

const UscBasketDetailsTotalPrice = (): JSX.Element => {
    const [totalMonthlyLabel, totalCashLabel, loadingLabel] = useUscLabel([
        "uscBasketOverviewTotalMonthly",
        "uscBasketOverviewTotalCash",
        "uscLoading",
    ]);
    const activeFinanceOption = useUscSelector((state) => state.basket.activeFinanceOption);
    const { cashLoading } = useUscSelector(getTotalPriceSelector(), shallowEqual);
    const { monthly } = useUscSelector(getSimplifiedTotalPriceSelector(true), shallowEqual);
    const showPricesInsideToggle = useUscSelector((state) => !state.uscSettings.hideFinanceTogglePrices);

    return (
        <Styles.Wrapper>
            {showPricesInsideToggle ? (
                <Styles.Prices>
                    <Text variant="h7">{activeFinanceOption === "cash" ? totalCashLabel : totalMonthlyLabel}</Text>
                    {activeFinanceOption === "cash" && (
                        <Text variant="body-small-semibold">
                            {cashLoading ? loadingLabel : <UscCashPrice showDiscountPrice />}
                        </Text>
                    )}
                    {activeFinanceOption === "monthly" && (
                        <Text variant="body-small-semibold">
                            <span dangerouslySetInnerHTML={{ __html: monthly }} />
                        </Text>
                    )}
                </Styles.Prices>
            ) : (
                <UscInlinePrices inBasketDetailsModal />
            )}
            <InlineDisclaimer
                disclaimerType={activeFinanceOption === "cash" ? UscDisclaimerType.Cash : UscDisclaimerType.Finance}
            />
        </Styles.Wrapper>
    );
};

export default UscBasketDetailsTotalPrice;
